export * from '../models/AddContactsInCvDto';
export * from '../models/AdminCreateOrderDto';
export * from '../models/AdminLoginRequestDTO';
export * from '../models/AdminLoginResponseDTO';
export * from '../models/AdminOrderTransactionsPaginationDTO';
export * from '../models/ArticleCategory';
export * from '../models/Asset';
export * from '../models/AssignPromoCodeQueryDto';
export * from '../models/AuthProfileSessionCurrentDTO';
export * from '../models/AuthProfileSessionDTO';
export * from '../models/AuthProfileSessionPushDTO';
export * from '../models/AuthProfileTokenDTO';
export * from '../models/AuthResponseDTO';
export * from '../models/AuthVerificationCodeDTO';
export * from '../models/AuthVerificationResponseDTO';
export * from '../models/AuthVerificationVerifyDTO';
export * from '../models/BackgroundCategory';
export * from '../models/BannerFindManyControllerFindMany0200Response';
export * from '../models/BannerItemContentDTO';
export * from '../models/BannerItemContentSourceDTO';
export * from '../models/BannerItemCreateDTO';
export * from '../models/BannerItemDTO';
export * from '../models/BannerItemProfileDTO';
export * from '../models/BannerItemUpdateDTO';
export * from '../models/BannerPaginationResponseDTO';
export * from '../models/BannerResponseDTO';
export * from '../models/CallbackResponseDto';
export * from '../models/CharacterItem';
export * from '../models/CharacterItemCategory';
export * from '../models/Course';
export * from '../models/CreateDepositPassimPayRequestDto';
export * from '../models/CreateManyAdminDto';
export * from '../models/CreateManyApplicationDto';
export * from '../models/CreateManyArticleCategoryDto';
export * from '../models/CreateManyAssetDto';
export * from '../models/CreateManyBackgroundCategoryDto';
export * from '../models/CreateManyBackgroundDto';
export * from '../models/CreateManyCVDto';
export * from '../models/CreateManyCharacterDto';
export * from '../models/CreateManyCharacterItemCategoryDto';
export * from '../models/CreateManyCharacterItemDto';
export * from '../models/CreateManyChatDto';
export * from '../models/CreateManyChatMessageDto';
export * from '../models/CreateManyChatMessageUrlDto';
export * from '../models/CreateManyCommunityDto';
export * from '../models/CreateManyCoverLetterDto';
export * from '../models/CreateManyFavouriteFolderDto';
export * from '../models/CreateManyFeedbackDto';
export * from '../models/CreateManyGeoDto';
export * from '../models/CreateManyGeonameDto';
export * from '../models/CreateManyPageHTMLBlockDto';
export * from '../models/CreateManyPersonalPageDto';
export * from '../models/CreateManyProfileDto';
export * from '../models/CreateManyProposalDto';
export * from '../models/CreateManyServiceCategoryDto';
export * from '../models/CreateManySkillDto';
export * from '../models/CreateManySourceDto';
export * from '../models/CreateManyStopWordDto';
export * from '../models/CreateManyVacancyDto';
export * from '../models/CreateManyVerticalDto';
export * from '../models/CreateOrderQueryDto';
export * from '../models/CreatePageJsonBlockDto';
export * from '../models/CreatePageJsonBlockTranslationDto';
export * from '../models/CreatePassimPayDepositResponseDto';
export * from '../models/CreatePassimPayTestDepositResponseDto';
export * from '../models/CreateProductDTO';
export * from '../models/CreatePromoCodeQueryDto';
export * from '../models/CreateTestDepositPassimPayOptionRequestDto';
export * from '../models/CreateTestDepositPassimPayRequestDto';
export * from '../models/GetDepositLinkResponseDto';
export * from '../models/GetManyAdminResponseDto';
export * from '../models/GetManyApplicationResponseDto';
export * from '../models/GetManyArticleCategoryResponseDto';
export * from '../models/GetManyArticleResponseDto';
export * from '../models/GetManyAssetResponseDto';
export * from '../models/GetManyBackgroundCategoryResponseDto';
export * from '../models/GetManyBackgroundResponseDto';
export * from '../models/GetManyBaseAdminControllerAdmin200Response';
export * from '../models/GetManyBaseApplicationAdminControllerApplication200Response';
export * from '../models/GetManyBaseArticleCategoryAdminControllerArticleCategory200Response';
export * from '../models/GetManyBaseArticleKnowledgeAdminControllerArticle200Response';
export * from '../models/GetManyBaseAssetAdminControllerAsset200Response';
export * from '../models/GetManyBaseBackgroundAdminControllerBackground200Response';
export * from '../models/GetManyBaseBackgroundCategoryAdminControllerBackgroundCategory200Response';
export * from '../models/GetManyBaseCVAdminControllerCV200Response';
export * from '../models/GetManyBaseCharacterAdminControllerCharacter200Response';
export * from '../models/GetManyBaseCharacterItemAdminControllerCharacterItem200Response';
export * from '../models/GetManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory200Response';
export * from '../models/GetManyBaseChatAdminControllerChat200Response';
export * from '../models/GetManyBaseChatMessageAdminControllerChatMessage200Response';
export * from '../models/GetManyBaseChatMessageUrlControllerChatMessageUrl200Response';
export * from '../models/GetManyBaseCommunityAdminControllerCommunity200Response';
export * from '../models/GetManyBaseCourseAuthorAdminControllerCourseAuthor200Response';
export * from '../models/GetManyBaseCourseBlockAdminControllerCourseBlock200Response';
export * from '../models/GetManyBaseCourseBlockStepAdminControllerCourseBlockStep200Response';
export * from '../models/GetManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer200Response';
export * from '../models/GetManyBaseCourseModuleAdminControllerCourseModule200Response';
export * from '../models/GetManyBaseCoverLetterAdminControllerCoverLetter200Response';
export * from '../models/GetManyBaseFavouriteFolderAdminControllerFavouriteFolder200Response';
export * from '../models/GetManyBaseFeedbackAdminControllerFeedback200Response';
export * from '../models/GetManyBaseGeoAdminControllerGeo200Response';
export * from '../models/GetManyBaseLocationAdminControllerGeoname200Response';
export * from '../models/GetManyBaseManagerAdminControllerProfile200Response';
export * from '../models/GetManyBasePageAdminControllerPageHTMLBlock200Response';
export * from '../models/GetManyBasePaymentAdminControllerPaymentTransaction200Response';
export * from '../models/GetManyBasePersonalPageAdminControllerPersonalPage200Response';
export * from '../models/GetManyBaseProposalAdminControllerProposal200Response';
export * from '../models/GetManyBaseServiceCategoryAdminControllerServiceCategory200Response';
export * from '../models/GetManyBaseSkillAdminControllerSkill200Response';
export * from '../models/GetManyBaseSourceAdminControllerSource200Response';
export * from '../models/GetManyBaseStopWordAdminControllerStopWord200Response';
export * from '../models/GetManyBaseStoryAdminControllerStory200Response';
export * from '../models/GetManyBaseStoryBlockAdminControllerStoryBlock200Response';
export * from '../models/GetManyBaseVerticalAdminControllerVertical200Response';
export * from '../models/GetManyCVResponseDto';
export * from '../models/GetManyCharacterItemCategoryResponseDto';
export * from '../models/GetManyCharacterItemResponseDto';
export * from '../models/GetManyCharacterResponseDto';
export * from '../models/GetManyChatFolderResponseDto';
export * from '../models/GetManyChatMessageResponseDto';
export * from '../models/GetManyChatMessageUrlResponseDto';
export * from '../models/GetManyChatResponseDto';
export * from '../models/GetManyCommunityResponseDto';
export * from '../models/GetManyCourseAuthorResponseDto';
export * from '../models/GetManyCourseBlockResponseDto';
export * from '../models/GetManyCourseBlockStepAnswerResponseDto';
export * from '../models/GetManyCourseBlockStepResponseDto';
export * from '../models/GetManyCourseModuleResponseDto';
export * from '../models/GetManyCourseResponseDto';
export * from '../models/GetManyCoverLetterResponseDto';
export * from '../models/GetManyFavouriteFolderResponseDto';
export * from '../models/GetManyFeedbackResponseDto';
export * from '../models/GetManyGeoResponseDto';
export * from '../models/GetManyGeonameResponseDto';
export * from '../models/GetManyPageHTMLBlockResponseDto';
export * from '../models/GetManyPaymentTransactionResponseDto';
export * from '../models/GetManyPersonalPageResponseDto';
export * from '../models/GetManyProfileResponseDto';
export * from '../models/GetManyProposalResponseDto';
export * from '../models/GetManyServiceCategoryResponseDto';
export * from '../models/GetManySkillResponseDto';
export * from '../models/GetManySourceResponseDto';
export * from '../models/GetManyStopWordResponseDto';
export * from '../models/GetManyStoryBlockResponseDto';
export * from '../models/GetManyStoryResponseDto';
export * from '../models/GetManyVacancyResponseDto';
export * from '../models/GetManyVerticalResponseDto';
export * from '../models/GetPaymentMethodsRequestDto';
export * from '../models/GetPaymentMethodsResponseDto';
export * from '../models/GetTransactionTotalAmountRequestDto';
export * from '../models/GetTransactionTotalAmountResponseDto';
export * from '../models/GiftPromotionAvailabilityDTO';
export * from '../models/HealthControllerCheck0200Response';
export * from '../models/HealthControllerCheck0200ResponseInfoValue';
export * from '../models/HealthControllerCheck0503Response';
export * from '../models/InfluenceCategoryControllerPaginate0200Response';
export * from '../models/InfluenceCategoryDTO';
export * from '../models/InfluenceDirectionControllerPaginate0200Response';
export * from '../models/InfluenceDirectionDTO';
export * from '../models/InfluencePlatformControllerPaginate0200Response';
export * from '../models/InfluencePlatformDTO';
export * from '../models/InfluenceResumeChannelCategoryDTO';
export * from '../models/InfluenceResumeChannelDTO';
export * from '../models/InfluenceResumeChannelDestroyDTO';
export * from '../models/InfluenceResumeChannelMutableDTO';
export * from '../models/InfluenceResumeChannelPlatformDTO';
export * from '../models/InfluenceResumeChannelPriceDTO';
export * from '../models/InfluenceResumeChannelPriceDestroyDTO';
export * from '../models/InfluenceResumeChannelPriceMutableDTO';
export * from '../models/InfluenceResumeContactsDTO';
export * from '../models/InfluenceResumeDTO';
export * from '../models/InfluenceResumePaginateControllerPaginate0200Response';
export * from '../models/InfluenceResumeStatisticDTO';
export * from '../models/ManagerCreateDTO';
export * from '../models/ManagerResponseDTO';
export * from '../models/ManagerUpdateDTO';
export * from '../models/NotificationCustomContentDTO';
export * from '../models/NotificationProfileCategoryDTO';
export * from '../models/NotificationProfileCategorySettingsDTO';
export * from '../models/NotificationProfileDTO';
export * from '../models/NotificationProfileProviderDTO';
export * from '../models/NotificationProfileProviderGenerateDTO';
export * from '../models/NotificationProfileProviderSettingsDTO';
export * from '../models/NotificationProfileProviderUnLinkDTO';
export * from '../models/NotificationProfileReadDTO';
export * from '../models/NotificationProfileRootDTO';
export * from '../models/OrderEntity';
export * from '../models/OrderTransactionEntity';
export * from '../models/PageHTMLBlock';
export * from '../models/PageJsonBlock';
export * from '../models/PageJsonBlockTranslation';
export * from '../models/PaginationResponseDTO';
export * from '../models/PaymentMethodDto';
export * from '../models/PaymentSystemDto';
export * from '../models/ProductEntity';
export * from '../models/ProductEntityContents';
export * from '../models/ProductLocalizationDTO';
export * from '../models/ProductLocalizationFeatureDTO';
export * from '../models/ProductProfileContentDTO';
export * from '../models/ProductVacancyContentDTO';
export * from '../models/ProfileAdminFindManyControllerFindMany0200Response';
export * from '../models/ProfileCityDTO';
export * from '../models/ProfileCountryDTO';
export * from '../models/ProfileItemDTO';
export * from '../models/ProfileResponseDTO';
export * from '../models/ProfileStatsDTO';
export * from '../models/ProfileStatsDTONewCVsCount';
export * from '../models/ProfileStatsDTONewVacanciesCount';
export * from '../models/ProfileStatsDTOResponsesCount';
export * from '../models/ProfileStatsDTOViewsCount';
export * from '../models/ProfileUpdateDTO';
export * from '../models/PromoCodeListQueryPaginationDTO';
export * from '../models/PromoCodeListResponseDto';
export * from '../models/PromoCodeResponseDto';
export * from '../models/QueryFilterDTO';
export * from '../models/QuerySortDTO';
export * from '../models/ServiceCategory';
export * from '../models/UpdatePageJsonBlockDto';
export * from '../models/UpdateProductDTO';
export * from '../models/UpdatePromoCodeQueryDto';
export * from '../models/UtilsProfileCompletedDTO';
export * from '../models/VacancyBodyDTO';
export * from '../models/VacancyPaginationDTO';
export * from '../models/VacancyQueryManyDTO';
export * from '../models/VacancyQueryStatsDTO';

import { AddContactsInCvDto } from '../models/AddContactsInCvDto';
import { AdminCreateOrderDto, AdminCreateOrderDtoProfileTypeEnum    } from '../models/AdminCreateOrderDto';
import { AdminLoginRequestDTO } from '../models/AdminLoginRequestDTO';
import { AdminLoginResponseDTO } from '../models/AdminLoginResponseDTO';
import { AdminOrderTransactionsPaginationDTO } from '../models/AdminOrderTransactionsPaginationDTO';
import { ArticleCategory } from '../models/ArticleCategory';
import { Asset } from '../models/Asset';
import { AssignPromoCodeQueryDto } from '../models/AssignPromoCodeQueryDto';
import { AuthProfileSessionCurrentDTO } from '../models/AuthProfileSessionCurrentDTO';
import { AuthProfileSessionDTO } from '../models/AuthProfileSessionDTO';
import { AuthProfileSessionPushDTO } from '../models/AuthProfileSessionPushDTO';
import { AuthProfileTokenDTO } from '../models/AuthProfileTokenDTO';
import { AuthResponseDTO } from '../models/AuthResponseDTO';
import { AuthVerificationCodeDTO } from '../models/AuthVerificationCodeDTO';
import { AuthVerificationResponseDTO } from '../models/AuthVerificationResponseDTO';
import { AuthVerificationVerifyDTO } from '../models/AuthVerificationVerifyDTO';
import { BackgroundCategory } from '../models/BackgroundCategory';
import { BannerFindManyControllerFindMany0200Response } from '../models/BannerFindManyControllerFindMany0200Response';
import { BannerItemContentDTO } from '../models/BannerItemContentDTO';
import { BannerItemContentSourceDTO } from '../models/BannerItemContentSourceDTO';
import { BannerItemCreateDTO, BannerItemCreateDTOLanguageEnum   , BannerItemCreateDTOPositionEnum  , BannerItemCreateDTOProfileTypeEnum        } from '../models/BannerItemCreateDTO';
import { BannerItemDTO, BannerItemDTOLanguageEnum    , BannerItemDTOPositionEnum    , BannerItemDTOProfileTypeEnum         } from '../models/BannerItemDTO';
import { BannerItemProfileDTO, BannerItemProfileDTOPositionEnum     } from '../models/BannerItemProfileDTO';
import { BannerItemUpdateDTO, BannerItemUpdateDTOLanguageEnum   , BannerItemUpdateDTOPositionEnum  , BannerItemUpdateDTOProfileTypeEnum        } from '../models/BannerItemUpdateDTO';
import { BannerPaginationResponseDTO } from '../models/BannerPaginationResponseDTO';
import { BannerResponseDTO } from '../models/BannerResponseDTO';
import { CallbackResponseDto } from '../models/CallbackResponseDto';
import { CharacterItem } from '../models/CharacterItem';
import { CharacterItemCategory } from '../models/CharacterItemCategory';
import { Course } from '../models/Course';
import { CreateDepositPassimPayRequestDto    , CreateDepositPassimPayRequestDtoTypeEnum   } from '../models/CreateDepositPassimPayRequestDto';
import { CreateManyAdminDto } from '../models/CreateManyAdminDto';
import { CreateManyApplicationDto } from '../models/CreateManyApplicationDto';
import { CreateManyArticleCategoryDto } from '../models/CreateManyArticleCategoryDto';
import { CreateManyAssetDto } from '../models/CreateManyAssetDto';
import { CreateManyBackgroundCategoryDto } from '../models/CreateManyBackgroundCategoryDto';
import { CreateManyBackgroundDto } from '../models/CreateManyBackgroundDto';
import { CreateManyCVDto } from '../models/CreateManyCVDto';
import { CreateManyCharacterDto } from '../models/CreateManyCharacterDto';
import { CreateManyCharacterItemCategoryDto } from '../models/CreateManyCharacterItemCategoryDto';
import { CreateManyCharacterItemDto } from '../models/CreateManyCharacterItemDto';
import { CreateManyChatDto } from '../models/CreateManyChatDto';
import { CreateManyChatMessageDto } from '../models/CreateManyChatMessageDto';
import { CreateManyChatMessageUrlDto } from '../models/CreateManyChatMessageUrlDto';
import { CreateManyCommunityDto } from '../models/CreateManyCommunityDto';
import { CreateManyCoverLetterDto } from '../models/CreateManyCoverLetterDto';
import { CreateManyFavouriteFolderDto } from '../models/CreateManyFavouriteFolderDto';
import { CreateManyFeedbackDto } from '../models/CreateManyFeedbackDto';
import { CreateManyGeoDto } from '../models/CreateManyGeoDto';
import { CreateManyGeonameDto } from '../models/CreateManyGeonameDto';
import { CreateManyPageHTMLBlockDto } from '../models/CreateManyPageHTMLBlockDto';
import { CreateManyPersonalPageDto } from '../models/CreateManyPersonalPageDto';
import { CreateManyProfileDto } from '../models/CreateManyProfileDto';
import { CreateManyProposalDto } from '../models/CreateManyProposalDto';
import { CreateManyServiceCategoryDto } from '../models/CreateManyServiceCategoryDto';
import { CreateManySkillDto } from '../models/CreateManySkillDto';
import { CreateManySourceDto } from '../models/CreateManySourceDto';
import { CreateManyStopWordDto } from '../models/CreateManyStopWordDto';
import { CreateManyVacancyDto } from '../models/CreateManyVacancyDto';
import { CreateManyVerticalDto } from '../models/CreateManyVerticalDto';
import { CreateOrderQueryDto } from '../models/CreateOrderQueryDto';
import { CreatePageJsonBlockDto } from '../models/CreatePageJsonBlockDto';
import { CreatePageJsonBlockTranslationDto  , CreatePageJsonBlockTranslationDtoLanguageCodeEnum   } from '../models/CreatePageJsonBlockTranslationDto';
import { CreatePassimPayDepositResponseDto , CreatePassimPayDepositResponseDtoStatusEnum    } from '../models/CreatePassimPayDepositResponseDto';
import { CreatePassimPayTestDepositResponseDto , CreatePassimPayTestDepositResponseDtoStatusEnum    } from '../models/CreatePassimPayTestDepositResponseDto';
import { CreateProductDTO } from '../models/CreateProductDTO';
import { CreatePromoCodeQueryDto  , CreatePromoCodeQueryDtoTypeEnum  , CreatePromoCodeQueryDtoProductTypeEnum    , CreatePromoCodeQueryDtoStatusEnum        } from '../models/CreatePromoCodeQueryDto';
import { CreateTestDepositPassimPayOptionRequestDto } from '../models/CreateTestDepositPassimPayOptionRequestDto';
import { CreateTestDepositPassimPayRequestDto    , CreateTestDepositPassimPayRequestDtoTypeEnum    } from '../models/CreateTestDepositPassimPayRequestDto';
import { GetDepositLinkResponseDto } from '../models/GetDepositLinkResponseDto';
import { GetManyAdminResponseDto } from '../models/GetManyAdminResponseDto';
import { GetManyApplicationResponseDto } from '../models/GetManyApplicationResponseDto';
import { GetManyArticleCategoryResponseDto } from '../models/GetManyArticleCategoryResponseDto';
import { GetManyArticleResponseDto } from '../models/GetManyArticleResponseDto';
import { GetManyAssetResponseDto } from '../models/GetManyAssetResponseDto';
import { GetManyBackgroundCategoryResponseDto } from '../models/GetManyBackgroundCategoryResponseDto';
import { GetManyBackgroundResponseDto } from '../models/GetManyBackgroundResponseDto';
import { GetManyBaseAdminControllerAdmin200ResponseClass } from '../models/GetManyBaseAdminControllerAdmin200Response';
import { GetManyBaseApplicationAdminControllerApplication200ResponseClass } from '../models/GetManyBaseApplicationAdminControllerApplication200Response';
import { GetManyBaseArticleCategoryAdminControllerArticleCategory200ResponseClass } from '../models/GetManyBaseArticleCategoryAdminControllerArticleCategory200Response';
import { GetManyBaseArticleKnowledgeAdminControllerArticle200ResponseClass } from '../models/GetManyBaseArticleKnowledgeAdminControllerArticle200Response';
import { GetManyBaseAssetAdminControllerAsset200ResponseClass } from '../models/GetManyBaseAssetAdminControllerAsset200Response';
import { GetManyBaseBackgroundAdminControllerBackground200ResponseClass } from '../models/GetManyBaseBackgroundAdminControllerBackground200Response';
import { GetManyBaseBackgroundCategoryAdminControllerBackgroundCategory200ResponseClass } from '../models/GetManyBaseBackgroundCategoryAdminControllerBackgroundCategory200Response';
import { GetManyBaseCVAdminControllerCV200ResponseClass } from '../models/GetManyBaseCVAdminControllerCV200Response';
import { GetManyBaseCharacterAdminControllerCharacter200ResponseClass } from '../models/GetManyBaseCharacterAdminControllerCharacter200Response';
import { GetManyBaseCharacterItemAdminControllerCharacterItem200ResponseClass } from '../models/GetManyBaseCharacterItemAdminControllerCharacterItem200Response';
import { GetManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory200ResponseClass } from '../models/GetManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory200Response';
import { GetManyBaseChatAdminControllerChat200ResponseClass } from '../models/GetManyBaseChatAdminControllerChat200Response';
import { GetManyBaseChatMessageAdminControllerChatMessage200ResponseClass } from '../models/GetManyBaseChatMessageAdminControllerChatMessage200Response';
import { GetManyBaseChatMessageUrlControllerChatMessageUrl200ResponseClass } from '../models/GetManyBaseChatMessageUrlControllerChatMessageUrl200Response';
import { GetManyBaseCommunityAdminControllerCommunity200ResponseClass } from '../models/GetManyBaseCommunityAdminControllerCommunity200Response';
import { GetManyBaseCourseAuthorAdminControllerCourseAuthor200ResponseClass } from '../models/GetManyBaseCourseAuthorAdminControllerCourseAuthor200Response';
import { GetManyBaseCourseBlockAdminControllerCourseBlock200ResponseClass } from '../models/GetManyBaseCourseBlockAdminControllerCourseBlock200Response';
import { GetManyBaseCourseBlockStepAdminControllerCourseBlockStep200ResponseClass } from '../models/GetManyBaseCourseBlockStepAdminControllerCourseBlockStep200Response';
import { GetManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer200ResponseClass } from '../models/GetManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer200Response';
import { GetManyBaseCourseModuleAdminControllerCourseModule200ResponseClass } from '../models/GetManyBaseCourseModuleAdminControllerCourseModule200Response';
import { GetManyBaseCoverLetterAdminControllerCoverLetter200ResponseClass } from '../models/GetManyBaseCoverLetterAdminControllerCoverLetter200Response';
import { GetManyBaseFavouriteFolderAdminControllerFavouriteFolder200ResponseClass } from '../models/GetManyBaseFavouriteFolderAdminControllerFavouriteFolder200Response';
import { GetManyBaseFeedbackAdminControllerFeedback200ResponseClass } from '../models/GetManyBaseFeedbackAdminControllerFeedback200Response';
import { GetManyBaseGeoAdminControllerGeo200ResponseClass } from '../models/GetManyBaseGeoAdminControllerGeo200Response';
import { GetManyBaseLocationAdminControllerGeoname200ResponseClass } from '../models/GetManyBaseLocationAdminControllerGeoname200Response';
import { GetManyBaseManagerAdminControllerProfile200ResponseClass } from '../models/GetManyBaseManagerAdminControllerProfile200Response';
import { GetManyBasePageAdminControllerPageHTMLBlock200ResponseClass } from '../models/GetManyBasePageAdminControllerPageHTMLBlock200Response';
import { GetManyBasePaymentAdminControllerPaymentTransaction200ResponseClass } from '../models/GetManyBasePaymentAdminControllerPaymentTransaction200Response';
import { GetManyBasePersonalPageAdminControllerPersonalPage200ResponseClass } from '../models/GetManyBasePersonalPageAdminControllerPersonalPage200Response';
import { GetManyBaseProposalAdminControllerProposal200ResponseClass } from '../models/GetManyBaseProposalAdminControllerProposal200Response';
import { GetManyBaseServiceCategoryAdminControllerServiceCategory200ResponseClass } from '../models/GetManyBaseServiceCategoryAdminControllerServiceCategory200Response';
import { GetManyBaseSkillAdminControllerSkill200ResponseClass } from '../models/GetManyBaseSkillAdminControllerSkill200Response';
import { GetManyBaseSourceAdminControllerSource200ResponseClass } from '../models/GetManyBaseSourceAdminControllerSource200Response';
import { GetManyBaseStopWordAdminControllerStopWord200ResponseClass } from '../models/GetManyBaseStopWordAdminControllerStopWord200Response';
import { GetManyBaseStoryAdminControllerStory200ResponseClass } from '../models/GetManyBaseStoryAdminControllerStory200Response';
import { GetManyBaseStoryBlockAdminControllerStoryBlock200ResponseClass } from '../models/GetManyBaseStoryBlockAdminControllerStoryBlock200Response';
import { GetManyBaseVerticalAdminControllerVertical200ResponseClass } from '../models/GetManyBaseVerticalAdminControllerVertical200Response';
import { GetManyCVResponseDto } from '../models/GetManyCVResponseDto';
import { GetManyCharacterItemCategoryResponseDto } from '../models/GetManyCharacterItemCategoryResponseDto';
import { GetManyCharacterItemResponseDto } from '../models/GetManyCharacterItemResponseDto';
import { GetManyCharacterResponseDto } from '../models/GetManyCharacterResponseDto';
import { GetManyChatFolderResponseDto } from '../models/GetManyChatFolderResponseDto';
import { GetManyChatMessageResponseDto } from '../models/GetManyChatMessageResponseDto';
import { GetManyChatMessageUrlResponseDto } from '../models/GetManyChatMessageUrlResponseDto';
import { GetManyChatResponseDto } from '../models/GetManyChatResponseDto';
import { GetManyCommunityResponseDto } from '../models/GetManyCommunityResponseDto';
import { GetManyCourseAuthorResponseDto } from '../models/GetManyCourseAuthorResponseDto';
import { GetManyCourseBlockResponseDto } from '../models/GetManyCourseBlockResponseDto';
import { GetManyCourseBlockStepAnswerResponseDto } from '../models/GetManyCourseBlockStepAnswerResponseDto';
import { GetManyCourseBlockStepResponseDto } from '../models/GetManyCourseBlockStepResponseDto';
import { GetManyCourseModuleResponseDto } from '../models/GetManyCourseModuleResponseDto';
import { GetManyCourseResponseDto } from '../models/GetManyCourseResponseDto';
import { GetManyCoverLetterResponseDto } from '../models/GetManyCoverLetterResponseDto';
import { GetManyFavouriteFolderResponseDto } from '../models/GetManyFavouriteFolderResponseDto';
import { GetManyFeedbackResponseDto } from '../models/GetManyFeedbackResponseDto';
import { GetManyGeoResponseDto } from '../models/GetManyGeoResponseDto';
import { GetManyGeonameResponseDto } from '../models/GetManyGeonameResponseDto';
import { GetManyPageHTMLBlockResponseDto } from '../models/GetManyPageHTMLBlockResponseDto';
import { GetManyPaymentTransactionResponseDto } from '../models/GetManyPaymentTransactionResponseDto';
import { GetManyPersonalPageResponseDto } from '../models/GetManyPersonalPageResponseDto';
import { GetManyProfileResponseDto } from '../models/GetManyProfileResponseDto';
import { GetManyProposalResponseDto } from '../models/GetManyProposalResponseDto';
import { GetManyServiceCategoryResponseDto } from '../models/GetManyServiceCategoryResponseDto';
import { GetManySkillResponseDto } from '../models/GetManySkillResponseDto';
import { GetManySourceResponseDto } from '../models/GetManySourceResponseDto';
import { GetManyStopWordResponseDto } from '../models/GetManyStopWordResponseDto';
import { GetManyStoryBlockResponseDto } from '../models/GetManyStoryBlockResponseDto';
import { GetManyStoryResponseDto } from '../models/GetManyStoryResponseDto';
import { GetManyVacancyResponseDto } from '../models/GetManyVacancyResponseDto';
import { GetManyVerticalResponseDto } from '../models/GetManyVerticalResponseDto';
import { GetPaymentMethodsRequestDto , GetPaymentMethodsRequestDtoNameEnum   , GetPaymentMethodsRequestDtoCodeEnum  , GetPaymentMethodsRequestDtoStatusEnum   } from '../models/GetPaymentMethodsRequestDto';
import { GetPaymentMethodsResponseDto } from '../models/GetPaymentMethodsResponseDto';
import { GetTransactionTotalAmountRequestDto , GetTransactionTotalAmountRequestDtoStatusEnum   } from '../models/GetTransactionTotalAmountRequestDto';
import { GetTransactionTotalAmountResponseDto } from '../models/GetTransactionTotalAmountResponseDto';
import { GiftPromotionAvailabilityDTO } from '../models/GiftPromotionAvailabilityDTO';
import { HealthControllerCheck0200Response } from '../models/HealthControllerCheck0200Response';
import { HealthControllerCheck0200ResponseInfoValue } from '../models/HealthControllerCheck0200ResponseInfoValue';
import { HealthControllerCheck0503Response } from '../models/HealthControllerCheck0503Response';
import { InfluenceCategoryControllerPaginate0200Response } from '../models/InfluenceCategoryControllerPaginate0200Response';
import { InfluenceCategoryDTO } from '../models/InfluenceCategoryDTO';
import { InfluenceDirectionControllerPaginate0200Response } from '../models/InfluenceDirectionControllerPaginate0200Response';
import { InfluenceDirectionDTO } from '../models/InfluenceDirectionDTO';
import { InfluencePlatformControllerPaginate0200Response } from '../models/InfluencePlatformControllerPaginate0200Response';
import { InfluencePlatformDTO } from '../models/InfluencePlatformDTO';
import { InfluenceResumeChannelCategoryDTO } from '../models/InfluenceResumeChannelCategoryDTO';
import { InfluenceResumeChannelDTO } from '../models/InfluenceResumeChannelDTO';
import { InfluenceResumeChannelDestroyDTO } from '../models/InfluenceResumeChannelDestroyDTO';
import { InfluenceResumeChannelMutableDTO } from '../models/InfluenceResumeChannelMutableDTO';
import { InfluenceResumeChannelPlatformDTO } from '../models/InfluenceResumeChannelPlatformDTO';
import { InfluenceResumeChannelPriceDTO } from '../models/InfluenceResumeChannelPriceDTO';
import { InfluenceResumeChannelPriceDestroyDTO } from '../models/InfluenceResumeChannelPriceDestroyDTO';
import { InfluenceResumeChannelPriceMutableDTO } from '../models/InfluenceResumeChannelPriceMutableDTO';
import { InfluenceResumeContactsDTO } from '../models/InfluenceResumeContactsDTO';
import { InfluenceResumeDTO } from '../models/InfluenceResumeDTO';
import { InfluenceResumePaginateControllerPaginate0200Response } from '../models/InfluenceResumePaginateControllerPaginate0200Response';
import { InfluenceResumeStatisticDTO } from '../models/InfluenceResumeStatisticDTO';
import { ManagerCreateDTO, ManagerCreateDTOHirerRoleEnum      , ManagerCreateDTOPermissionsEnum      } from '../models/ManagerCreateDTO';
import { ManagerResponseDTO } from '../models/ManagerResponseDTO';
import { ManagerUpdateDTO, ManagerUpdateDTOHirerRoleEnum      , ManagerUpdateDTOPermissionsEnum   } from '../models/ManagerUpdateDTO';
import { NotificationCustomContentDTO } from '../models/NotificationCustomContentDTO';
import { NotificationProfileCategoryDTO , NotificationProfileCategoryDTOTypeEnum    } from '../models/NotificationProfileCategoryDTO';
import { NotificationProfileCategorySettingsDTO, NotificationProfileCategorySettingsDTOTypesEnum   } from '../models/NotificationProfileCategorySettingsDTO';
import { NotificationProfileDTO } from '../models/NotificationProfileDTO';
import { NotificationProfileProviderDTO , NotificationProfileProviderDTOProviderEnum    } from '../models/NotificationProfileProviderDTO';
import { NotificationProfileProviderGenerateDTO } from '../models/NotificationProfileProviderGenerateDTO';
import { NotificationProfileProviderSettingsDTO, NotificationProfileProviderSettingsDTOTypesEnum   } from '../models/NotificationProfileProviderSettingsDTO';
import { NotificationProfileProviderUnLinkDTO, NotificationProfileProviderUnLinkDTOProviderEnum   } from '../models/NotificationProfileProviderUnLinkDTO';
import { NotificationProfileReadDTO } from '../models/NotificationProfileReadDTO';
import { NotificationProfileRootDTO } from '../models/NotificationProfileRootDTO';
import { OrderEntity } from '../models/OrderEntity';
import { OrderTransactionEntity } from '../models/OrderTransactionEntity';
import { PageHTMLBlock } from '../models/PageHTMLBlock';
import { PageJsonBlock } from '../models/PageJsonBlock';
import { PageJsonBlockTranslation } from '../models/PageJsonBlockTranslation';
import { PaginationResponseDTO } from '../models/PaginationResponseDTO';
import { PaymentMethodDto     , PaymentMethodDtoStatusEnum     } from '../models/PaymentMethodDto';
import { PaymentSystemDto   , PaymentSystemDtoStatusEnum    } from '../models/PaymentSystemDto';
import { ProductEntity } from '../models/ProductEntity';
import { ProductEntityContentsClass } from '../models/ProductEntityContents';
import { ProductLocalizationDTO } from '../models/ProductLocalizationDTO';
import { ProductLocalizationFeatureDTO } from '../models/ProductLocalizationFeatureDTO';
import { ProductProfileContentDTO, ProductProfileContentDTOTypeEnum     } from '../models/ProductProfileContentDTO';
import { ProductVacancyContentDTO, ProductVacancyContentDTOTypeEnum    , ProductVacancyContentDTOTariffEnum       } from '../models/ProductVacancyContentDTO';
import { ProfileAdminFindManyControllerFindMany0200Response } from '../models/ProfileAdminFindManyControllerFindMany0200Response';
import { ProfileCityDTO } from '../models/ProfileCityDTO';
import { ProfileCountryDTO } from '../models/ProfileCountryDTO';
import { ProfileItemDTO , ProfileItemDTOProfileTypeEnum   , ProfileItemDTOLanguageEnum           , ProfileItemDTOVacancyLookTypeEnum   , ProfileItemDTOGenderEnum   , ProfileItemDTOHirerRoleEnum  , ProfileItemDTOPermissionsEnum         } from '../models/ProfileItemDTO';
import { ProfileResponseDTO   , ProfileResponseDTOProfileTypeEnum   , ProfileResponseDTOLanguageEnum           , ProfileResponseDTOVacancyLookTypeEnum   , ProfileResponseDTOGenderEnum   , ProfileResponseDTOHirerRoleEnum  , ProfileResponseDTOPermissionsEnum         } from '../models/ProfileResponseDTO';
import { ProfileStatsDTO } from '../models/ProfileStatsDTO';
import { ProfileStatsDTONewCVsCount } from '../models/ProfileStatsDTONewCVsCount';
import { ProfileStatsDTONewVacanciesCount } from '../models/ProfileStatsDTONewVacanciesCount';
import { ProfileStatsDTOResponsesCount } from '../models/ProfileStatsDTOResponsesCount';
import { ProfileStatsDTOViewsCount } from '../models/ProfileStatsDTOViewsCount';
import { ProfileUpdateDTO  , ProfileUpdateDTOLanguageEnum     , ProfileUpdateDTOProfileTypeEnum         , ProfileUpdateDTOVacancyLookTypeEnum  , ProfileUpdateDTOGenderEnum   } from '../models/ProfileUpdateDTO';
import { PromoCodeListQueryPaginationDTO } from '../models/PromoCodeListQueryPaginationDTO';
import { PromoCodeListResponseDto } from '../models/PromoCodeListResponseDto';
import { PromoCodeResponseDto    , PromoCodeResponseDtoTypeEnum  , PromoCodeResponseDtoProductTypeEnum    , PromoCodeResponseDtoStatusEnum           } from '../models/PromoCodeResponseDto';
import { QueryFilterDTO , QueryFilterDTOOperatorEnum    } from '../models/QueryFilterDTO';
import { QuerySortDTO } from '../models/QuerySortDTO';
import { ServiceCategory } from '../models/ServiceCategory';
import { UpdatePageJsonBlockDto  , UpdatePageJsonBlockDtoLanguageCodeEnum   } from '../models/UpdatePageJsonBlockDto';
import { UpdateProductDTO } from '../models/UpdateProductDTO';
import { UpdatePromoCodeQueryDto   , UpdatePromoCodeQueryDtoTypeEnum  , UpdatePromoCodeQueryDtoProductTypeEnum    , UpdatePromoCodeQueryDtoStatusEnum       } from '../models/UpdatePromoCodeQueryDto';
import { UtilsProfileCompletedDTO } from '../models/UtilsProfileCompletedDTO';
import { VacancyBodyDTO                 , VacancyBodyDTOCompensationEnum  , VacancyBodyDTOCurrencyEnum  , VacancyBodyDTOExperienceEnum  , VacancyBodyDTOScheduleEnum  , VacancyBodyDTOEmploymentEnum                  } from '../models/VacancyBodyDTO';
import { VacancyPaginationDTO } from '../models/VacancyPaginationDTO';
import { VacancyQueryManyDTO              , VacancyQueryManyDTOEmploymentEnum  , VacancyQueryManyDTOScheduleEnum  , VacancyQueryManyDTOExperienceEnum  , VacancyQueryManyDTOCompensationEnum                     } from '../models/VacancyQueryManyDTO';
import { VacancyQueryStatsDTO    , VacancyQueryStatsDTOEmploymentEnum  , VacancyQueryStatsDTOScheduleEnum  , VacancyQueryStatsDTOCompensationEnum  , VacancyQueryStatsDTOExperienceEnum       } from '../models/VacancyQueryStatsDTO';

/* tslint:disable:no-unused-variable */
let primitives = [
                    "string",
                    "boolean",
                    "double",
                    "integer",
                    "long",
                    "float",
                    "number",
                    "any"
                 ];

let enumsMap: Set<string> = new Set<string>([
    "AdminCreateOrderDtoProfileTypeEnum",
    "BannerItemCreateDTOLanguageEnum",
    "BannerItemCreateDTOPositionEnum",
    "BannerItemCreateDTOProfileTypeEnum",
    "BannerItemDTOLanguageEnum",
    "BannerItemDTOPositionEnum",
    "BannerItemDTOProfileTypeEnum",
    "BannerItemProfileDTOPositionEnum",
    "BannerItemUpdateDTOLanguageEnum",
    "BannerItemUpdateDTOPositionEnum",
    "BannerItemUpdateDTOProfileTypeEnum",
    "CreateDepositPassimPayRequestDtoTypeEnum",
    "CreatePageJsonBlockTranslationDtoLanguageCodeEnum",
    "CreatePassimPayDepositResponseDtoStatusEnum",
    "CreatePassimPayTestDepositResponseDtoStatusEnum",
    "CreatePromoCodeQueryDtoTypeEnum",
    "CreatePromoCodeQueryDtoProductTypeEnum",
    "CreatePromoCodeQueryDtoStatusEnum",
    "CreateTestDepositPassimPayRequestDtoTypeEnum",
    "GetPaymentMethodsRequestDtoNameEnum",
    "GetPaymentMethodsRequestDtoCodeEnum",
    "GetPaymentMethodsRequestDtoStatusEnum",
    "GetTransactionTotalAmountRequestDtoStatusEnum",
    "ManagerCreateDTOHirerRoleEnum",
    "ManagerCreateDTOPermissionsEnum",
    "ManagerUpdateDTOHirerRoleEnum",
    "ManagerUpdateDTOPermissionsEnum",
    "NotificationProfileCategoryDTOTypeEnum",
    "NotificationProfileCategorySettingsDTOTypesEnum",
    "NotificationProfileProviderDTOProviderEnum",
    "NotificationProfileProviderSettingsDTOTypesEnum",
    "NotificationProfileProviderUnLinkDTOProviderEnum",
    "PaymentMethodDtoStatusEnum",
    "PaymentSystemDtoStatusEnum",
    "ProductEntityContentsTypeEnum",
    "ProductEntityContentsTariffEnum",
    "ProductProfileContentDTOTypeEnum",
    "ProductVacancyContentDTOTypeEnum",
    "ProductVacancyContentDTOTariffEnum",
    "ProfileItemDTOProfileTypeEnum",
    "ProfileItemDTOLanguageEnum",
    "ProfileItemDTOVacancyLookTypeEnum",
    "ProfileItemDTOGenderEnum",
    "ProfileItemDTOHirerRoleEnum",
    "ProfileItemDTOPermissionsEnum",
    "ProfileResponseDTOProfileTypeEnum",
    "ProfileResponseDTOLanguageEnum",
    "ProfileResponseDTOVacancyLookTypeEnum",
    "ProfileResponseDTOGenderEnum",
    "ProfileResponseDTOHirerRoleEnum",
    "ProfileResponseDTOPermissionsEnum",
    "ProfileUpdateDTOLanguageEnum",
    "ProfileUpdateDTOProfileTypeEnum",
    "ProfileUpdateDTOVacancyLookTypeEnum",
    "ProfileUpdateDTOGenderEnum",
    "PromoCodeResponseDtoTypeEnum",
    "PromoCodeResponseDtoProductTypeEnum",
    "PromoCodeResponseDtoStatusEnum",
    "QueryFilterDTOOperatorEnum",
    "UpdatePageJsonBlockDtoLanguageCodeEnum",
    "UpdatePromoCodeQueryDtoTypeEnum",
    "UpdatePromoCodeQueryDtoProductTypeEnum",
    "UpdatePromoCodeQueryDtoStatusEnum",
    "VacancyBodyDTOCompensationEnum",
    "VacancyBodyDTOCurrencyEnum",
    "VacancyBodyDTOExperienceEnum",
    "VacancyBodyDTOScheduleEnum",
    "VacancyBodyDTOEmploymentEnum",
    "VacancyQueryManyDTOEmploymentEnum",
    "VacancyQueryManyDTOScheduleEnum",
    "VacancyQueryManyDTOExperienceEnum",
    "VacancyQueryManyDTOCompensationEnum",
    "VacancyQueryStatsDTOEmploymentEnum",
    "VacancyQueryStatsDTOScheduleEnum",
    "VacancyQueryStatsDTOCompensationEnum",
    "VacancyQueryStatsDTOExperienceEnum",
]);

let typeMap: {[index: string]: any} = {
    "AddContactsInCvDto": AddContactsInCvDto,
    "AdminCreateOrderDto": AdminCreateOrderDto,
    "AdminLoginRequestDTO": AdminLoginRequestDTO,
    "AdminLoginResponseDTO": AdminLoginResponseDTO,
    "AdminOrderTransactionsPaginationDTO": AdminOrderTransactionsPaginationDTO,
    "ArticleCategory": ArticleCategory,
    "Asset": Asset,
    "AssignPromoCodeQueryDto": AssignPromoCodeQueryDto,
    "AuthProfileSessionCurrentDTO": AuthProfileSessionCurrentDTO,
    "AuthProfileSessionDTO": AuthProfileSessionDTO,
    "AuthProfileSessionPushDTO": AuthProfileSessionPushDTO,
    "AuthProfileTokenDTO": AuthProfileTokenDTO,
    "AuthResponseDTO": AuthResponseDTO,
    "AuthVerificationCodeDTO": AuthVerificationCodeDTO,
    "AuthVerificationResponseDTO": AuthVerificationResponseDTO,
    "AuthVerificationVerifyDTO": AuthVerificationVerifyDTO,
    "BackgroundCategory": BackgroundCategory,
    "BannerFindManyControllerFindMany0200Response": BannerFindManyControllerFindMany0200Response,
    "BannerItemContentDTO": BannerItemContentDTO,
    "BannerItemContentSourceDTO": BannerItemContentSourceDTO,
    "BannerItemCreateDTO": BannerItemCreateDTO,
    "BannerItemDTO": BannerItemDTO,
    "BannerItemProfileDTO": BannerItemProfileDTO,
    "BannerItemUpdateDTO": BannerItemUpdateDTO,
    "BannerPaginationResponseDTO": BannerPaginationResponseDTO,
    "BannerResponseDTO": BannerResponseDTO,
    "CallbackResponseDto": CallbackResponseDto,
    "CharacterItem": CharacterItem,
    "CharacterItemCategory": CharacterItemCategory,
    "Course": Course,
    "CreateDepositPassimPayRequestDto": CreateDepositPassimPayRequestDto,
    "CreateManyAdminDto": CreateManyAdminDto,
    "CreateManyApplicationDto": CreateManyApplicationDto,
    "CreateManyArticleCategoryDto": CreateManyArticleCategoryDto,
    "CreateManyAssetDto": CreateManyAssetDto,
    "CreateManyBackgroundCategoryDto": CreateManyBackgroundCategoryDto,
    "CreateManyBackgroundDto": CreateManyBackgroundDto,
    "CreateManyCVDto": CreateManyCVDto,
    "CreateManyCharacterDto": CreateManyCharacterDto,
    "CreateManyCharacterItemCategoryDto": CreateManyCharacterItemCategoryDto,
    "CreateManyCharacterItemDto": CreateManyCharacterItemDto,
    "CreateManyChatDto": CreateManyChatDto,
    "CreateManyChatMessageDto": CreateManyChatMessageDto,
    "CreateManyChatMessageUrlDto": CreateManyChatMessageUrlDto,
    "CreateManyCommunityDto": CreateManyCommunityDto,
    "CreateManyCoverLetterDto": CreateManyCoverLetterDto,
    "CreateManyFavouriteFolderDto": CreateManyFavouriteFolderDto,
    "CreateManyFeedbackDto": CreateManyFeedbackDto,
    "CreateManyGeoDto": CreateManyGeoDto,
    "CreateManyGeonameDto": CreateManyGeonameDto,
    "CreateManyPageHTMLBlockDto": CreateManyPageHTMLBlockDto,
    "CreateManyPersonalPageDto": CreateManyPersonalPageDto,
    "CreateManyProfileDto": CreateManyProfileDto,
    "CreateManyProposalDto": CreateManyProposalDto,
    "CreateManyServiceCategoryDto": CreateManyServiceCategoryDto,
    "CreateManySkillDto": CreateManySkillDto,
    "CreateManySourceDto": CreateManySourceDto,
    "CreateManyStopWordDto": CreateManyStopWordDto,
    "CreateManyVacancyDto": CreateManyVacancyDto,
    "CreateManyVerticalDto": CreateManyVerticalDto,
    "CreateOrderQueryDto": CreateOrderQueryDto,
    "CreatePageJsonBlockDto": CreatePageJsonBlockDto,
    "CreatePageJsonBlockTranslationDto": CreatePageJsonBlockTranslationDto,
    "CreatePassimPayDepositResponseDto": CreatePassimPayDepositResponseDto,
    "CreatePassimPayTestDepositResponseDto": CreatePassimPayTestDepositResponseDto,
    "CreateProductDTO": CreateProductDTO,
    "CreatePromoCodeQueryDto": CreatePromoCodeQueryDto,
    "CreateTestDepositPassimPayOptionRequestDto": CreateTestDepositPassimPayOptionRequestDto,
    "CreateTestDepositPassimPayRequestDto": CreateTestDepositPassimPayRequestDto,
    "GetDepositLinkResponseDto": GetDepositLinkResponseDto,
    "GetManyAdminResponseDto": GetManyAdminResponseDto,
    "GetManyApplicationResponseDto": GetManyApplicationResponseDto,
    "GetManyArticleCategoryResponseDto": GetManyArticleCategoryResponseDto,
    "GetManyArticleResponseDto": GetManyArticleResponseDto,
    "GetManyAssetResponseDto": GetManyAssetResponseDto,
    "GetManyBackgroundCategoryResponseDto": GetManyBackgroundCategoryResponseDto,
    "GetManyBackgroundResponseDto": GetManyBackgroundResponseDto,
    "GetManyBaseAdminControllerAdmin200Response": GetManyBaseAdminControllerAdmin200ResponseClass,
    "GetManyBaseApplicationAdminControllerApplication200Response": GetManyBaseApplicationAdminControllerApplication200ResponseClass,
    "GetManyBaseArticleCategoryAdminControllerArticleCategory200Response": GetManyBaseArticleCategoryAdminControllerArticleCategory200ResponseClass,
    "GetManyBaseArticleKnowledgeAdminControllerArticle200Response": GetManyBaseArticleKnowledgeAdminControllerArticle200ResponseClass,
    "GetManyBaseAssetAdminControllerAsset200Response": GetManyBaseAssetAdminControllerAsset200ResponseClass,
    "GetManyBaseBackgroundAdminControllerBackground200Response": GetManyBaseBackgroundAdminControllerBackground200ResponseClass,
    "GetManyBaseBackgroundCategoryAdminControllerBackgroundCategory200Response": GetManyBaseBackgroundCategoryAdminControllerBackgroundCategory200ResponseClass,
    "GetManyBaseCVAdminControllerCV200Response": GetManyBaseCVAdminControllerCV200ResponseClass,
    "GetManyBaseCharacterAdminControllerCharacter200Response": GetManyBaseCharacterAdminControllerCharacter200ResponseClass,
    "GetManyBaseCharacterItemAdminControllerCharacterItem200Response": GetManyBaseCharacterItemAdminControllerCharacterItem200ResponseClass,
    "GetManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory200Response": GetManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory200ResponseClass,
    "GetManyBaseChatAdminControllerChat200Response": GetManyBaseChatAdminControllerChat200ResponseClass,
    "GetManyBaseChatMessageAdminControllerChatMessage200Response": GetManyBaseChatMessageAdminControllerChatMessage200ResponseClass,
    "GetManyBaseChatMessageUrlControllerChatMessageUrl200Response": GetManyBaseChatMessageUrlControllerChatMessageUrl200ResponseClass,
    "GetManyBaseCommunityAdminControllerCommunity200Response": GetManyBaseCommunityAdminControllerCommunity200ResponseClass,
    "GetManyBaseCourseAuthorAdminControllerCourseAuthor200Response": GetManyBaseCourseAuthorAdminControllerCourseAuthor200ResponseClass,
    "GetManyBaseCourseBlockAdminControllerCourseBlock200Response": GetManyBaseCourseBlockAdminControllerCourseBlock200ResponseClass,
    "GetManyBaseCourseBlockStepAdminControllerCourseBlockStep200Response": GetManyBaseCourseBlockStepAdminControllerCourseBlockStep200ResponseClass,
    "GetManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer200Response": GetManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer200ResponseClass,
    "GetManyBaseCourseModuleAdminControllerCourseModule200Response": GetManyBaseCourseModuleAdminControllerCourseModule200ResponseClass,
    "GetManyBaseCoverLetterAdminControllerCoverLetter200Response": GetManyBaseCoverLetterAdminControllerCoverLetter200ResponseClass,
    "GetManyBaseFavouriteFolderAdminControllerFavouriteFolder200Response": GetManyBaseFavouriteFolderAdminControllerFavouriteFolder200ResponseClass,
    "GetManyBaseFeedbackAdminControllerFeedback200Response": GetManyBaseFeedbackAdminControllerFeedback200ResponseClass,
    "GetManyBaseGeoAdminControllerGeo200Response": GetManyBaseGeoAdminControllerGeo200ResponseClass,
    "GetManyBaseLocationAdminControllerGeoname200Response": GetManyBaseLocationAdminControllerGeoname200ResponseClass,
    "GetManyBaseManagerAdminControllerProfile200Response": GetManyBaseManagerAdminControllerProfile200ResponseClass,
    "GetManyBasePageAdminControllerPageHTMLBlock200Response": GetManyBasePageAdminControllerPageHTMLBlock200ResponseClass,
    "GetManyBasePaymentAdminControllerPaymentTransaction200Response": GetManyBasePaymentAdminControllerPaymentTransaction200ResponseClass,
    "GetManyBasePersonalPageAdminControllerPersonalPage200Response": GetManyBasePersonalPageAdminControllerPersonalPage200ResponseClass,
    "GetManyBaseProposalAdminControllerProposal200Response": GetManyBaseProposalAdminControllerProposal200ResponseClass,
    "GetManyBaseServiceCategoryAdminControllerServiceCategory200Response": GetManyBaseServiceCategoryAdminControllerServiceCategory200ResponseClass,
    "GetManyBaseSkillAdminControllerSkill200Response": GetManyBaseSkillAdminControllerSkill200ResponseClass,
    "GetManyBaseSourceAdminControllerSource200Response": GetManyBaseSourceAdminControllerSource200ResponseClass,
    "GetManyBaseStopWordAdminControllerStopWord200Response": GetManyBaseStopWordAdminControllerStopWord200ResponseClass,
    "GetManyBaseStoryAdminControllerStory200Response": GetManyBaseStoryAdminControllerStory200ResponseClass,
    "GetManyBaseStoryBlockAdminControllerStoryBlock200Response": GetManyBaseStoryBlockAdminControllerStoryBlock200ResponseClass,
    "GetManyBaseVerticalAdminControllerVertical200Response": GetManyBaseVerticalAdminControllerVertical200ResponseClass,
    "GetManyCVResponseDto": GetManyCVResponseDto,
    "GetManyCharacterItemCategoryResponseDto": GetManyCharacterItemCategoryResponseDto,
    "GetManyCharacterItemResponseDto": GetManyCharacterItemResponseDto,
    "GetManyCharacterResponseDto": GetManyCharacterResponseDto,
    "GetManyChatFolderResponseDto": GetManyChatFolderResponseDto,
    "GetManyChatMessageResponseDto": GetManyChatMessageResponseDto,
    "GetManyChatMessageUrlResponseDto": GetManyChatMessageUrlResponseDto,
    "GetManyChatResponseDto": GetManyChatResponseDto,
    "GetManyCommunityResponseDto": GetManyCommunityResponseDto,
    "GetManyCourseAuthorResponseDto": GetManyCourseAuthorResponseDto,
    "GetManyCourseBlockResponseDto": GetManyCourseBlockResponseDto,
    "GetManyCourseBlockStepAnswerResponseDto": GetManyCourseBlockStepAnswerResponseDto,
    "GetManyCourseBlockStepResponseDto": GetManyCourseBlockStepResponseDto,
    "GetManyCourseModuleResponseDto": GetManyCourseModuleResponseDto,
    "GetManyCourseResponseDto": GetManyCourseResponseDto,
    "GetManyCoverLetterResponseDto": GetManyCoverLetterResponseDto,
    "GetManyFavouriteFolderResponseDto": GetManyFavouriteFolderResponseDto,
    "GetManyFeedbackResponseDto": GetManyFeedbackResponseDto,
    "GetManyGeoResponseDto": GetManyGeoResponseDto,
    "GetManyGeonameResponseDto": GetManyGeonameResponseDto,
    "GetManyPageHTMLBlockResponseDto": GetManyPageHTMLBlockResponseDto,
    "GetManyPaymentTransactionResponseDto": GetManyPaymentTransactionResponseDto,
    "GetManyPersonalPageResponseDto": GetManyPersonalPageResponseDto,
    "GetManyProfileResponseDto": GetManyProfileResponseDto,
    "GetManyProposalResponseDto": GetManyProposalResponseDto,
    "GetManyServiceCategoryResponseDto": GetManyServiceCategoryResponseDto,
    "GetManySkillResponseDto": GetManySkillResponseDto,
    "GetManySourceResponseDto": GetManySourceResponseDto,
    "GetManyStopWordResponseDto": GetManyStopWordResponseDto,
    "GetManyStoryBlockResponseDto": GetManyStoryBlockResponseDto,
    "GetManyStoryResponseDto": GetManyStoryResponseDto,
    "GetManyVacancyResponseDto": GetManyVacancyResponseDto,
    "GetManyVerticalResponseDto": GetManyVerticalResponseDto,
    "GetPaymentMethodsRequestDto": GetPaymentMethodsRequestDto,
    "GetPaymentMethodsResponseDto": GetPaymentMethodsResponseDto,
    "GetTransactionTotalAmountRequestDto": GetTransactionTotalAmountRequestDto,
    "GetTransactionTotalAmountResponseDto": GetTransactionTotalAmountResponseDto,
    "GiftPromotionAvailabilityDTO": GiftPromotionAvailabilityDTO,
    "HealthControllerCheck0200Response": HealthControllerCheck0200Response,
    "HealthControllerCheck0200ResponseInfoValue": HealthControllerCheck0200ResponseInfoValue,
    "HealthControllerCheck0503Response": HealthControllerCheck0503Response,
    "InfluenceCategoryControllerPaginate0200Response": InfluenceCategoryControllerPaginate0200Response,
    "InfluenceCategoryDTO": InfluenceCategoryDTO,
    "InfluenceDirectionControllerPaginate0200Response": InfluenceDirectionControllerPaginate0200Response,
    "InfluenceDirectionDTO": InfluenceDirectionDTO,
    "InfluencePlatformControllerPaginate0200Response": InfluencePlatformControllerPaginate0200Response,
    "InfluencePlatformDTO": InfluencePlatformDTO,
    "InfluenceResumeChannelCategoryDTO": InfluenceResumeChannelCategoryDTO,
    "InfluenceResumeChannelDTO": InfluenceResumeChannelDTO,
    "InfluenceResumeChannelDestroyDTO": InfluenceResumeChannelDestroyDTO,
    "InfluenceResumeChannelMutableDTO": InfluenceResumeChannelMutableDTO,
    "InfluenceResumeChannelPlatformDTO": InfluenceResumeChannelPlatformDTO,
    "InfluenceResumeChannelPriceDTO": InfluenceResumeChannelPriceDTO,
    "InfluenceResumeChannelPriceDestroyDTO": InfluenceResumeChannelPriceDestroyDTO,
    "InfluenceResumeChannelPriceMutableDTO": InfluenceResumeChannelPriceMutableDTO,
    "InfluenceResumeContactsDTO": InfluenceResumeContactsDTO,
    "InfluenceResumeDTO": InfluenceResumeDTO,
    "InfluenceResumePaginateControllerPaginate0200Response": InfluenceResumePaginateControllerPaginate0200Response,
    "InfluenceResumeStatisticDTO": InfluenceResumeStatisticDTO,
    "ManagerCreateDTO": ManagerCreateDTO,
    "ManagerResponseDTO": ManagerResponseDTO,
    "ManagerUpdateDTO": ManagerUpdateDTO,
    "NotificationCustomContentDTO": NotificationCustomContentDTO,
    "NotificationProfileCategoryDTO": NotificationProfileCategoryDTO,
    "NotificationProfileCategorySettingsDTO": NotificationProfileCategorySettingsDTO,
    "NotificationProfileDTO": NotificationProfileDTO,
    "NotificationProfileProviderDTO": NotificationProfileProviderDTO,
    "NotificationProfileProviderGenerateDTO": NotificationProfileProviderGenerateDTO,
    "NotificationProfileProviderSettingsDTO": NotificationProfileProviderSettingsDTO,
    "NotificationProfileProviderUnLinkDTO": NotificationProfileProviderUnLinkDTO,
    "NotificationProfileReadDTO": NotificationProfileReadDTO,
    "NotificationProfileRootDTO": NotificationProfileRootDTO,
    "OrderEntity": OrderEntity,
    "OrderTransactionEntity": OrderTransactionEntity,
    "PageHTMLBlock": PageHTMLBlock,
    "PageJsonBlock": PageJsonBlock,
    "PageJsonBlockTranslation": PageJsonBlockTranslation,
    "PaginationResponseDTO": PaginationResponseDTO,
    "PaymentMethodDto": PaymentMethodDto,
    "PaymentSystemDto": PaymentSystemDto,
    "ProductEntity": ProductEntity,
    "ProductEntityContents": ProductEntityContentsClass,
    "ProductLocalizationDTO": ProductLocalizationDTO,
    "ProductLocalizationFeatureDTO": ProductLocalizationFeatureDTO,
    "ProductProfileContentDTO": ProductProfileContentDTO,
    "ProductVacancyContentDTO": ProductVacancyContentDTO,
    "ProfileAdminFindManyControllerFindMany0200Response": ProfileAdminFindManyControllerFindMany0200Response,
    "ProfileCityDTO": ProfileCityDTO,
    "ProfileCountryDTO": ProfileCountryDTO,
    "ProfileItemDTO": ProfileItemDTO,
    "ProfileResponseDTO": ProfileResponseDTO,
    "ProfileStatsDTO": ProfileStatsDTO,
    "ProfileStatsDTONewCVsCount": ProfileStatsDTONewCVsCount,
    "ProfileStatsDTONewVacanciesCount": ProfileStatsDTONewVacanciesCount,
    "ProfileStatsDTOResponsesCount": ProfileStatsDTOResponsesCount,
    "ProfileStatsDTOViewsCount": ProfileStatsDTOViewsCount,
    "ProfileUpdateDTO": ProfileUpdateDTO,
    "PromoCodeListQueryPaginationDTO": PromoCodeListQueryPaginationDTO,
    "PromoCodeListResponseDto": PromoCodeListResponseDto,
    "PromoCodeResponseDto": PromoCodeResponseDto,
    "QueryFilterDTO": QueryFilterDTO,
    "QuerySortDTO": QuerySortDTO,
    "ServiceCategory": ServiceCategory,
    "UpdatePageJsonBlockDto": UpdatePageJsonBlockDto,
    "UpdateProductDTO": UpdateProductDTO,
    "UpdatePromoCodeQueryDto": UpdatePromoCodeQueryDto,
    "UtilsProfileCompletedDTO": UtilsProfileCompletedDTO,
    "VacancyBodyDTO": VacancyBodyDTO,
    "VacancyPaginationDTO": VacancyPaginationDTO,
    "VacancyQueryManyDTO": VacancyQueryManyDTO,
    "VacancyQueryStatsDTO": VacancyQueryStatsDTO,
}

type MimeTypeDescriptor = {
    type: string;
    subtype: string;
    subtypeTokens: string[];
};

/**
 * Every mime-type consists of a type, subtype, and optional parameters.
 * The subtype can be composite, including information about the content format.
 * For example: `application/json-patch+json`, `application/merge-patch+json`.
 *
 * This helper transforms a string mime-type into an internal representation.
 * This simplifies the implementation of predicates that in turn define common rules for parsing or stringifying
 * the payload.
 */
const parseMimeType = (mimeType: string): MimeTypeDescriptor => {
    const [type = '', subtype = ''] = mimeType.split('/');
    return {
        type,
        subtype,
        subtypeTokens: subtype.split('+'),
    };
};

type MimeTypePredicate = (mimeType: string) => boolean;

// This factory creates a predicate function that checks a string mime-type against defined rules.
const mimeTypePredicateFactory = (predicate: (descriptor: MimeTypeDescriptor) => boolean): MimeTypePredicate => (mimeType) => predicate(parseMimeType(mimeType));

// Use this factory when you need to define a simple predicate based only on type and, if applicable, subtype.
const mimeTypeSimplePredicateFactory = (type: string, subtype?: string): MimeTypePredicate => mimeTypePredicateFactory((descriptor) => {
    if (descriptor.type !== type) return false;
    if (subtype != null && descriptor.subtype !== subtype) return false;
    return true;
});

// Creating a set of named predicates that will help us determine how to handle different mime-types
const isTextLikeMimeType = mimeTypeSimplePredicateFactory('text');
const isJsonMimeType = mimeTypeSimplePredicateFactory('application', 'json');
const isJsonLikeMimeType = mimeTypePredicateFactory((descriptor) => descriptor.type === 'application' && descriptor.subtypeTokens.some((item) => item === 'json'));
const isOctetStreamMimeType = mimeTypeSimplePredicateFactory('application', 'octet-stream');
const isFormUrlencodedMimeType = mimeTypeSimplePredicateFactory('application', 'x-www-form-urlencoded');

// Defining a list of mime-types in the order of prioritization for handling.
const supportedMimeTypePredicatesWithPriority: MimeTypePredicate[] = [
    isJsonMimeType,
    isJsonLikeMimeType,
    isTextLikeMimeType,
    isOctetStreamMimeType,
    isFormUrlencodedMimeType,
];

const nullableSuffix = " | null";
const optionalSuffix = " | undefined";
const arrayPrefix = "Array<";
const arraySuffix = ">";
const mapPrefix = "{ [key: string]: ";
const mapSuffix = "; }";

export class ObjectSerializer {
    public static findCorrectType(data: any, expectedType: string) {
        if (data == undefined) {
            return expectedType;
        } else if (primitives.indexOf(expectedType.toLowerCase()) !== -1) {
            return expectedType;
        } else if (expectedType === "Date") {
            return expectedType;
        } else {
            if (enumsMap.has(expectedType)) {
                return expectedType;
            }

            if (!typeMap[expectedType]) {
                return expectedType; // w/e we don't know the type
            }

            // Check the discriminator
            let discriminatorProperty = typeMap[expectedType].discriminator;
            if (discriminatorProperty == null) {
                return expectedType; // the type does not have a discriminator. use it.
            } else {
                if (data[discriminatorProperty]) {
                    var discriminatorType = data[discriminatorProperty];
                    let mapping = typeMap[expectedType].mapping;
                    if (mapping != undefined && mapping[discriminatorType]) {
                        return mapping[discriminatorType]; // use the type given in the discriminator
                    } else if(typeMap[discriminatorType]) {
                        return discriminatorType;
                    } else {
                        return expectedType; // discriminator did not map to a type
                    }
                } else {
                    return expectedType; // discriminator was not present (or an empty string)
                }
            }
        }
    }

    public static serialize(data: any, type: string, format: string): any {
        if (data == undefined) {
            return data;
        } else if (primitives.indexOf(type.toLowerCase()) !== -1) {
            return data;
        } else if (type.endsWith(nullableSuffix)) {
            let subType: string = type.slice(0, -nullableSuffix.length); // Type | null => Type
            return ObjectSerializer.serialize(data, subType, format);
        } else if (type.endsWith(optionalSuffix)) {
            let subType: string = type.slice(0, -optionalSuffix.length); // Type | undefined => Type
            return ObjectSerializer.serialize(data, subType, format);
        } else if (type.startsWith(arrayPrefix)) {
            let subType: string = type.slice(arrayPrefix.length, -arraySuffix.length); // Array<Type> => Type
            let transformedData: any[] = [];
            for (let date of data) {
                transformedData.push(ObjectSerializer.serialize(date, subType, format));
            }
            return transformedData;
        } else if (type.startsWith(mapPrefix)) {
            let subType: string = type.slice(mapPrefix.length, -mapSuffix.length); // { [key: string]: Type; } => Type
            let transformedData: { [key: string]: any } = {};
            for (let key in data) {
                transformedData[key] = ObjectSerializer.serialize(
                    data[key],
                    subType,
                    format,
                );
            }
            return transformedData;
        } else if (type === "Date") {
            if (format == "date") {
                let month = data.getMonth()+1
                month = month < 10 ? "0" + month.toString() : month.toString()
                let day = data.getDate();
                day = day < 10 ? "0" + day.toString() : day.toString();

                return data.getFullYear() + "-" + month + "-" + day;
            } else {
                return data.toISOString();
            }
        } else {
            if (enumsMap.has(type)) {
                return data;
            }
            if (!typeMap[type]) { // in case we dont know the type
                return data;
            }

            // Get the actual type of this object
            type = this.findCorrectType(data, type);

            // get the map for the correct type.
            let attributeTypes = typeMap[type].getAttributeTypeMap();
            let instance: {[index: string]: any} = {};
            for (let attributeType of attributeTypes) {
                instance[attributeType.baseName] = ObjectSerializer.serialize(data[attributeType.name], attributeType.type, attributeType.format);
            }
            return instance;
        }
    }

    public static deserialize(data: any, type: string, format: string): any {
        // polymorphism may change the actual type.
        type = ObjectSerializer.findCorrectType(data, type);
        if (data == undefined) {
            return data;
        } else if (primitives.indexOf(type.toLowerCase()) !== -1) {
            return data;
        } else if (type.endsWith(nullableSuffix)) {
            let subType: string = type.slice(0, -nullableSuffix.length); // Type | null => Type
            return ObjectSerializer.deserialize(data, subType, format);
        } else if (type.endsWith(optionalSuffix)) {
            let subType: string = type.slice(0, -optionalSuffix.length); // Type | undefined => Type
            return ObjectSerializer.deserialize(data, subType, format);
        } else if (type.startsWith(arrayPrefix)) {
            let subType: string = type.slice(arrayPrefix.length, -arraySuffix.length); // Array<Type> => Type
            let transformedData: any[] = [];
            for (let date of data) {
                transformedData.push(ObjectSerializer.deserialize(date, subType, format));
            }
            return transformedData;
        } else if (type.startsWith(mapPrefix)) {
            let subType: string = type.slice(mapPrefix.length, -mapSuffix.length); // { [key: string]: Type; } => Type
            let transformedData: { [key: string]: any } = {};
            for (let key in data) {
                transformedData[key] = ObjectSerializer.deserialize(
                    data[key],
                    subType,
                    format,
                );
            }
            return transformedData;
        } else if (type === "Date") {
            return new Date(data);
        } else {
            if (enumsMap.has(type)) {// is Enum
                return data;
            }

            if (!typeMap[type]) { // dont know the type
                return data;
            }
            let instance = new typeMap[type]();
            let attributeTypes = typeMap[type].getAttributeTypeMap();
            for (let attributeType of attributeTypes) {
                let value = ObjectSerializer.deserialize(data[attributeType.baseName], attributeType.type, attributeType.format);
                if (value !== undefined) {
                    instance[attributeType.name] = value;
                }
            }
            return instance;
        }
    }


    /**
     * Normalize media type
     *
     * We currently do not handle any media types attributes, i.e. anything
     * after a semicolon. All content is assumed to be UTF-8 compatible.
     */
    public static normalizeMediaType(mediaType: string | undefined): string | undefined {
        if (mediaType === undefined) {
            return undefined;
        }
        return (mediaType.split(";")[0] ?? '').trim().toLowerCase();
    }

    /**
     * From a list of possible media types, choose the one we can handle best.
     *
     * The order of the given media types does not have any impact on the choice
     * made.
     */
    public static getPreferredMediaType(mediaTypes: Array<string>): string {
        /** According to OAS 3 we should default to json */
        if (mediaTypes.length === 0) {
            return "application/json";
        }

        const normalMediaTypes = mediaTypes.map(ObjectSerializer.normalizeMediaType);

        for (const predicate of supportedMimeTypePredicatesWithPriority) {
            for (const mediaType of normalMediaTypes) {
                if (mediaType != null && predicate(mediaType)) {
                    return mediaType;
                }
            }
        }

        throw new Error("None of the given media types are supported: " + mediaTypes.join(", "));
    }

    /**
     * Convert data to a string according the given media type
     */
    public static stringify(data: any, mediaType: string): string {
        if (isTextLikeMimeType(mediaType)) {
            return String(data);
        }

        if (isJsonLikeMimeType(mediaType)) {
            return JSON.stringify(data);
        }

        throw new Error("The mediaType " + mediaType + " is not supported by ObjectSerializer.stringify.");
    }

    /**
     * Parse data from a string according to the given media type
     */
    public static parse(rawData: string, mediaType: string | undefined) {
        if (mediaType === undefined) {
            throw new Error("Cannot parse content. No Content-Type defined.");
        }

        if (isTextLikeMimeType(mediaType)) {
            return rawData;
        }

        if (isJsonLikeMimeType(mediaType)) {
            return JSON.parse(rawData);
        }

        throw new Error("The mediaType " + mediaType + " is not supported by ObjectSerializer.parse.");
    }
}
